module.exports = __webpack_public_path__ + "static/media/Arun Mukherjee.e890d5f4.jpg";